import React from 'react';
import Filter from "../../../components/datatable/Filter";
import {CALENDAR_FILTER_OPTIONS} from "../constants";
import {format} from "date-fns";

const Header = (props) => {
    const {
        currentDate           = new Date(),
        typeFilter            = "",
        jobTypeFilter         = "",
        userFilter            = "",
        onPrevClick           = () => {},
        onNextClick           = () => {},
        onTypeFilterChange    = (value) => {},
        onJobTypeFilterChange = (value) => {},
        onUserFilterChange    = (value) => {},
        jobTypes              = [],
        users                 = [],
    } = props;

    return (
        <div className="calendar-header row">
            <div className="col-12 col-xl-3 d-flex flex-row mb-3">
                <button className="calendar-button prev" onClick={() =>  onPrevClick()}>
                    <i className="fas fa-chevron-left fa-2x" />
                </button>
                <button className="calendar-button next" onClick={() => onNextClick()}>
                    <i className="fas fa-chevron-right fa-2x" />
                </button>
                <div className="calendar-title ml-3">
                    {format(currentDate, "MMMM yyyy")}
                </div>
            </div>
            <Filter
                label="Type:"
                value={typeFilter}
                options={Object.values(CALENDAR_FILTER_OPTIONS)}
                name="filter_type"
                onChange={(value) => onTypeFilterChange(value)}
                classes="col-12 col-xl-3 mb-3 text-right"
            />
            <Filter
                label="Job Type:"
                value={jobTypeFilter}
                options={jobTypes}
                name="filter_job_type"
                onChange={(value) => onJobTypeFilterChange(value)}
                classes="col-12 col-xl-3 mb-3 text-right"
            />
            <Filter
                label="User:"
                value={userFilter}
                options={users}
                name="filter_user"
                onChange={(value) => onUserFilterChange(value)}
                classes="col-12 col-xl-3 mb-3 text-right"
            />
        </div>
    );
}

export default Header;
